










































































import AutocompleteVue from '@/components/Autocomplete.vue'
import { filterMixin } from '@/utils/mixins/filterMixin'
import { getUsers } from '@/api/Users/users.api'
import RangeDatePicker from '@/components/RangeDatePicker.vue'
import { DatePicker } from '@/utils/interfaces'
import { chipClasses } from '@/utils/chipClasses.constant'
import UserListItem from '@/components/UserListItem.vue'
import { mapState } from 'vuex'
import { getUsersPayment } from '~/api/Agency/agency.api'
import FlatFilter from '~/components/FlatFilter.vue'

export default filterMixin.extend({
  components: {
    appAutocomplete: AutocompleteVue,
    appUsersListItem: UserListItem,
    appRangeDatePicker: RangeDatePicker,
    FlatFilter,
  },
  data: function() {
    return {
      getUsers: getUsers,
      chipClasses: chipClasses,
      statusItems: ['CONFIRMED', 'CANCELED', 'PENDING'],
      getUsersPayment,
    }
  },
  computed: {
    ...mapState(['profile']),
  },
  methods: {
    newFilter() {
      const createdAt = (this.$refs.createdDatePicker as DatePicker).getData()
      const confirmedAt = (this.$refs
        .confirmedDatePicker as DatePicker).getData()
      const canceledAt = (this.$refs.canceledDatePicker as DatePicker).getData()
      const filter = {
        ...this.filter,
        created_at__gte: createdAt.minDate,
        created_at__lte: createdAt.maxDate,
        confirmed_at__gte: confirmedAt.minDate,
        confirmed_at__lte: confirmedAt.maxDate,
        canceled_at__gte: canceledAt.minDate,
        canceled_at__lte: canceledAt.maxDate,
      } as { [key: string]: string }
      this.$emit('filter', filter)
    },
  },
})
